<template>
  <div id="my">
    <div class="bredcumb">
      <div class="container">
        <ul >
          <li><router-link to="/index"><a href="">首頁</a></router-link></li>
          <li><a href="/member/profile">我的</a></li>
          <li >{{this.getMyNavigators()}}</li>
        </ul>
      </div>
    </div>

    <div class="bodyContent user">
        <div class="container">
            <div class="row no-gutters">
              <div class="col-md-3">
                <nav class="sideNav">
                  <MyMenu></MyMenu>
                </nav>
              </div>
              <MyContents id="my-content" ></MyContents>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import MyMenu from './mySubviews/MyMenu'
import MyContents from './mySubviews/MyContents'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      myNavigator: ''
    }
  },

  computed: {

    // mix the getters into computed with object spread operator
    ...mapGetters([
      'myNavigators'
    ])
  },
  mounted () {
    // 會員header fixed
    var stickyHeader = $('.sideNav').offset().top

    $(window).scroll(function () {
      if ($(window).scrollTop() > stickyHeader) {
        $('.sideNav').addClass('affix')
      } else {
        $('.sideNav').removeClass('affix')
      }
    })
  },
  methods: {
    getMyNavigators () {
      var i
      for (i = 0; i < this.myNavigators.length; i++) {
        if (this.myNavigators[i].isSelected === true) {
          this.myNavigator = this.myNavigators[i].title
        }
        //   alert(this.myNavigators[i].isSelected);
      }
      return this.myNavigator
    }
  },
  components: {
    MyMenu,
    MyContents
  }
}
</script>

<style scoped>
/* @import '../../assets/css/user.css';
@import '../../assets/css/user_rwd.css'; */
/* @import '@/assets/css/user_rwd.css'; */
#my{
    background: #fbfbfb;
}

.user{
    padding: 18px;
}

 @media (min-width: 0px) and (max-width: 768px){
  #my {margin-top: -128px;}

}

</style>



// WEBPACK FOOTER //
// src/components/views/My.vue